import { AttachmentConfig } from "../comments.model";

export const truncateFileName = (fileName: string, maxLength: number) => {
  const lastDotIndex = fileName.lastIndexOf('.');
  const name = fileName.slice(0, lastDotIndex);
  const extension = fileName.slice(lastDotIndex);

  if (name.length <= maxLength) return fileName;

  const halfMaxLength = maxLength / 2;
  const truncatedName = `${name.slice(0, halfMaxLength)}...${name.slice(-halfMaxLength)}`;

  return `${truncatedName}${extension}`;
};

export const maxFileSize = 20;
export function attachmentValidator(
  file: File,
  config: AttachmentConfig = { maxSize: maxFileSize }
) {
  const MEGABYTES = 1024 * 1024;
  const limit = config.maxSize || 0;
  const maxSize = limit * MEGABYTES;
  const regexForFileValidator =
    /^(image\/.*|\.jpg|\.png|text\/plain|\.txt|application\/pdf|\.pdf)$/;

  if (file.size > maxSize) {
    return {
      code: 'file-too-large',
      message: `File is larger than ${limit}MB.`,
    };
  }

  if (!regexForFileValidator.test(file.type)) {
    return {
      code: 'file-invalid-type',
      message: 'File type must be .jpg, .png, .txt, .pdf.',
    };
  }

  return null;
}
